
<div
	class="flow-file-upload"
	:state="state"
	@click="handleClick"
	@drop.prevent="dropFile"
	@dragover.prevent
>
	<div class="flow-file-upload-title-container">
		<p v-if="title" class="paragraph-2 fc-dark">
			{{ title }}
		</p>
		<p v-if="subTitle" class="paragraph-2 fc-light">
			{{ subTitle }}
		</p>
	</div>
	<Icon name="i-upload" type="filled" />
	<input ref="fileInput" :accept="accept" type="file" @input="selectFile" />
</div>
